import { render } from "./FaqManageView.vue?vue&type=template&id=f6c27f12&scoped=true"
import script from "./FaqManageView.vue?vue&type=script&lang=js"
export * from "./FaqManageView.vue?vue&type=script&lang=js"

import "./FaqManageView.vue?vue&type=style&index=0&id=f6c27f12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c27f12"]])

export default __exports__